import { MARKETING_HUB_PROFESSIONAL, SALES_HUB_PROFESSIONAL, SERVICE_HUB_PROFESSIONAL } from 'self-service-api/constants/ApiNames';
import FeaturesMap from 'self-service-api/constants/FeaturesMap';
import { OPERATIONS_HUB_PROFESSIONAL } from 'self-service-api/constants/ProductNames';
export const BizObjectivesMap = {
  [MARKETING_HUB_PROFESSIONAL]: {
    automateAndPersonalizeYourEngagement: {
      illustration: 'social',
      features: {
        marketingAutomation: FeaturesMap.omniChannelMarketingAutomation.href,
        abmTools: FeaturesMap.abmToolsAndAutomation.href,
        dynamicPersonalization: FeaturesMap.dynamicPersonalization.href,
        multiLanguageContent: FeaturesMap.multiLanguageContent.href,
        socialMedia: FeaturesMap.socialMedia.href,
        videoHosting: FeaturesMap.videoHostingManagement.href,
        contactScoring: FeaturesMap.leadAndCompanyScoring.href
      }
    },
    orchestrateEfficientCampaigns: {
      illustration: 'content-strategy',
      features: {
        collaborationTools: FeaturesMap.collaborationTools.href,
        campaignManagement: FeaturesMap.campaignManagement.href,
        teams: FeaturesMap.teams.href
      }
    },
    optimizeCampaignConversion: {
      illustration: 'leads',
      features: {
        abTesting: FeaturesMap.abTesting.href,
        adConversion: FeaturesMap.adsOptimizationEvents.href,
        contactAttribution: FeaturesMap.attributionReporting.href
      }
    },
    buildCustomReports: {
      illustration: 'add-on-reporting',
      features: {
        webAnalytics: FeaturesMap.websiteTrafficAnalytics.href,
        campaignReporting: FeaturesMap.campaignReporting.href,
        customReporting: FeaturesMap.customReports.href,
        salesforceIntegration: FeaturesMap.salesforceIntegration.href
      }
    }
  },
  [SALES_HUB_PROFESSIONAL]: {
    personalizeYourOutreach: {
      illustration: 'personalization-tokens',
      features: {
        sequences: FeaturesMap.sequences.href,
        videoMessaging: FeaturesMap.sequences.href,
        smartSendTimes: FeaturesMap.smartSendTimes.href,
        abmTools: FeaturesMap.abmToolsAndAutomation.href
      }
    },
    manageYourGrowingTeam: {
      illustration: 'deal-pipeline-rules',
      features: {
        salesAnalytics: FeaturesMap.salesAnalytics.href,
        teams: FeaturesMap.teams.href,
        salesAutomation: FeaturesMap.salesAutomation.href,
        crmConfig: FeaturesMap.recordCustomization.href,
        requiredFields: FeaturesMap.requiredFields.href,
        customReporting: FeaturesMap.customReports.href
      }
    },
    configurePriceQuote: {
      illustration: 'electronic-signature',
      features: {
        productLibrary: FeaturesMap.products.href,
        calculatedProperties: FeaturesMap.calculatedProperties.href,
        esignature: FeaturesMap.eSign.href,
        forecast: FeaturesMap.forecasting.href
      }
    }
  },
  [SERVICE_HUB_PROFESSIONAL]: {
    scaleSupport: {
      illustration: 'customer-support',
      features: {
        helpDeskAutomation: FeaturesMap.customerServiceAutomation.href,
        ticketRouting: FeaturesMap.ticketRouting.href,
        knowledgeBase: FeaturesMap.knowledgeBase.href,
        sla: FeaturesMap.slas.href
      }
    },
    connectServiceToFrontOffice: {
      illustration: 'forecasting',
      features: {
        customerFeedback: FeaturesMap.customerFeedbackSurveys.href,
        forecast: FeaturesMap.forecasting.href
      }
    },
    expandCustomerRelationships: {
      illustration: 'service-hub-professional',
      features: {
        customerPortal: FeaturesMap.customerPortal.href,
        standardScoring: FeaturesMap.standardContactScoring.href,
        serviceAnalytics: FeaturesMap.serviceAnalytics.href
      }
    }
  },
  [OPERATIONS_HUB_PROFESSIONAL]: {
    automateBusinessProcesses: {
      illustration: 'workflows',
      features: {
        webhooks: FeaturesMap.webhooks.href,
        customCodedWorkflows: FeaturesMap.customCodedBotActions.href
      }
    },
    monitorAndCleanData: {
      illustration: 'record-data-density-modal',
      features: {
        dataQualityCommandCenter: FeaturesMap.dataQualityCommandCenter.href
      }
    },
    manageScalingBusiness: {
      illustration: 'business-hours',
      features: {
        teams: FeaturesMap.teams.href,
        requiredFields: FeaturesMap.requiredFields.href,
        crmConfig: FeaturesMap.recordCustomization.href
      }
    },
    buildCustomReports: {
      illustration: 'add-on-reporting',
      features: {
        customReporting: FeaturesMap.customReports.href,
        calculatedProperties: FeaturesMap.calculatedProperties.href,
        standardScoring: FeaturesMap.standardContactScoring.href,
        dealScoring: FeaturesMap.standardContactScoring.href
      }
    }
  }
};